var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buyInfoItem" }, [
    _c("img", {
      staticClass: "diamond_icon",
      attrs: { src: require("../assets/img/diamond.png") }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "fc-flex fc-flex-vcenter fc-flex1" }, [
      _c("span", { staticClass: "buyNum" }, [
        _vm._v(_vm._s(_vm.normInfo.newNumber))
      ]),
      _vm._v(" "),
      _vm.normInfo.awardNumber > 0
        ? _c("span", { staticClass: "morereward_txt" }, [
            _vm._v("+" + _vm._s(_vm.normInfo.awardNumber))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.normInfo.img && _vm.normInfo.isActivity
        ? _c("img", {
            staticClass: "morereward_img",
            attrs: { src: _vm.normInfo.img }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "fc-btn-line-main payBtn",
        on: {
          click: function($event) {
            return _vm.payforMoney(_vm.payType.rechargePayType, _vm.normInfo)
          }
        }
      },
      [_vm._v("\n        " + _vm._s(_vm.calLocalMoney()))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35f34059", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f34059","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buyItem.vue
// module id = null
// module chunks = 